import { alpha, ListItemButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Timeblock } from "./BerthOrdersDayList";

interface TimeBlockListItemProps {
  time: string;
  last: boolean;
  firstColumn: boolean;
  block: Timeblock;
}

export const TimeBlockListItem = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    prop !== "time" &&
    prop !== "last" &&
    prop !== "firstColumn" &&
    prop !== "block",
})<TimeBlockListItemProps>(({ time, last, firstColumn, block }) => ({
  padding: "5px",
  background: block.color ?? "#eaeff1",
  "&:hover": {
    background: block.color
      ? alpha(block.color, 0.6)
      : "rgba(157, 157, 157, 0.08)",
  },
  "&:before": {
    content: `"${time}"`,
    position: "absolute",
    top: "-11px",
    left: "-45px",
  },
  borderBottom: `1px solid ${
    !!block.nextBlock?.order || !!block.order || last
      ? "transparent"
      : "#404854"
  }`,
  "&:after": {
    content: last && firstColumn ? '"00:00"' : '""',
    width: 150,
    position: "absolute",
    left: "-45px",
    bottom: "-9px",
  },
  borderTopLeftRadius: block?.first ? "5px" : 0,
  borderTopRightRadius: block?.first ? "5px" : 0,
  borderBottomLeftRadius: block?.last ? "5px" : 0,
  borderBottomRightRadius: block?.last ? "5px" : 0,
}));
